var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_2153_16696)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1297 22.3844L22.7533 26.2143H38.2467L36.8703 22.3844C36.633 21.7272 35.9949 21.2857 35.2777 21.2857H25.7223C25.0051 21.2857 24.367 21.7272 24.1297 22.3844V22.3844ZM19.0883 26.4607L20.9445 21.3011C21.6564 19.3246 23.5707 18 25.7223 18H35.2777C37.4293 18 39.3436 19.3246 40.0555 21.3011L41.9117 26.4607C43.1352 26.9536 44 28.1292 44 29.5V39.3571C44 40.2658 43.2459 41 42.3125 41H40.625C39.6916 41 38.9375 40.2658 38.9375 39.3571V36.8929H22.0625V39.3571C22.0625 40.2658 21.3084 41 20.375 41H18.6875C17.7541 41 17 40.2658 17 39.3571V29.5C17 28.1292 17.8648 26.9536 19.0883 26.4607V26.4607ZM23.75 31.1429C23.75 30.2342 22.9959 29.5 22.0625 29.5C21.1291 29.5 20.375 30.2342 20.375 31.1429C20.375 32.0516 21.1291 32.7857 22.0625 32.7857C22.9959 32.7857 23.75 32.0516 23.75 31.1429ZM38.9375 32.7857C39.8709 32.7857 40.625 32.0516 40.625 31.1429C40.625 30.2342 39.8709 29.5 38.9375 29.5C38.0041 29.5 37.25 30.2342 37.25 31.1429C37.25 32.0516 38.0041 32.7857 38.9375 32.7857Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2153_16696",
    x1: 8,
    y1: 8.5,
    x2: 45.5,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADBBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87A6D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.747c25ac63e18d5b30c54d126fbca87e.svg";
export { ForwardRef as ReactComponent };